import { render } from "./Proyeccion-App.vue?vue&type=template&id=edf16822&scoped=true"
import script from "./Proyeccion-App.vue?vue&type=script&lang=js"
export * from "./Proyeccion-App.vue?vue&type=script&lang=js"

import "./Proyeccion-App.vue?vue&type=style&index=0&id=edf16822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf16822"]])

export default __exports__